module.exports = __webpack_public_path__ + "static/img/spirit.2c3fbb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AboutUS/spirit.png
// module id = JaU0
// module chunks = 7